import { ApiObjectService } from './api-object.service'

class DictionarySputteringsService extends ApiObjectService {
    namespace = 'dictionary-sputterings'
}

export const dictionarySputteringsService = new DictionarySputteringsService()
